var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8338 12.8333H12.8465C14.0094 12.8333 14.9762 11.8126 14.5173 10.7441C13.9386 9.39646 12.8686 8.5 11.3338 8.5C11.0364 8.5 10.7565 8.53365 10.4942 8.59772M7.50039 4.66667C7.50039 5.86328 6.53034 6.83333 5.33372 6.83333C4.13711 6.83333 3.16706 5.86328 3.16706 4.66667C3.16706 3.47005 4.13711 2.5 5.33372 2.5C6.53034 2.5 7.50039 3.47005 7.50039 4.66667ZM13.1671 5C13.1671 6.01252 12.3462 6.83333 11.3337 6.83333C10.3212 6.83333 9.50039 6.01252 9.50039 5C9.50039 3.98748 10.3212 3.16667 11.3337 3.16667C12.3462 3.16667 13.1671 3.98748 13.1671 5ZM1.59535 11.3978C2.21841 9.67267 3.47665 8.5 5.33372 8.5C7.1908 8.5 8.44904 9.67267 9.0721 11.3978C9.46683 12.4907 8.51083 13.5 7.34881 13.5H3.31863C2.15661 13.5 1.20062 12.4907 1.59535 11.3978Z",
    stroke: "#2FA9AB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.368535ae248e0b09c4c21c8f8eac18da.svg";
export { ForwardRef as ReactComponent };